import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ScanPlayOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ScanPlayOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M20.5 17.5c0 1.65-1.35 3-3 3H14v2h3.5c2.76 0 5-2.24 5-5V14h-2v3.5ZM17.5 1.5H14v2h3.5c1.65 0 3 1.35 3 3V10h2V6.5c0-2.76-2.24-5-5-5ZM3.5 6.5c0-1.65 1.35-3 3-3H10v-2H6.5c-2.76 0-5 2.24-5 5V10h2V6.5ZM3.5 17.5v-3h-2v3c0 2.76 2.24 5 5 5H10v-2H6.5c-1.65 0-3-1.35-3-3ZM9 16.5l7.5-4.5L9 7.5v9Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ScanPlayOutlined;